import { render, staticRenderFns } from "./InvestigationCard.vue?vue&type=template&id=bde4f004&scoped=true&"
import script from "./InvestigationCard.vue?vue&type=script&lang=js&"
export * from "./InvestigationCard.vue?vue&type=script&lang=js&"
import style0 from "./InvestigationCard.vue?vue&type=style&index=0&id=bde4f004&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde4f004",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardSubtitle,VCardTitle,VContainer,VHover,VImg})
